module.exports = __webpack_public_path__ + "img/ltkwedding-2x.6972cf5.jpg";